import type { ProductVariant } from "@commercetools/platform-sdk";
import { getVariantAttributeValue } from "./variant-service";

export const getLocalSku = (
	variant: Queries.ProductVariantFragment,
): string => {
	let attribute;

	const store = process.env.GATSBY_STORE;
	if (store) {
		switch (store.toUpperCase()) {
			case "US": {
				attribute = variant.attributes.find(
					(attribute) => attribute.name === "us-sku",
				);
				break;
			}
			case "CA": {
				attribute = variant.attributes.find(
					(attribute) => attribute.name === "ca-sku",
				);
				break;
			}
			case "UK": {
				attribute = variant.attributes.find(
					(attribute) => attribute.name === "uk-sku",
				);
				break;
			}
		}
	}

	if (
		attribute &&
		attribute.__typename === "CommerceToolsProductAttributeString" &&
		attribute.stringValue
	) {
		return attribute.stringValue;
	}

	return variant.sku || "";
};

export const getLocalSkuFromProductVariant = (
	variant: ProductVariant,
): string => {
	const storeKey = process.env.GATSBY_STORE;
	let sku: typeof variant.sku;

	if (storeKey) {
		switch (storeKey.toUpperCase()) {
			case "US": {
				sku = getVariantAttributeValue<string>(variant, "us-sku");
				break;
			}
			case "CA": {
				sku = getVariantAttributeValue<string>(variant, "ca-sku");
				break;
			}
			case "UK": {
				sku = getVariantAttributeValue<string>(variant, "uk-sku");
				break;
			}
		}
	}

	if (!sku) {
		sku = variant.sku || "";
	}

	return sku;
};
